const i = {
  "diagnostics-header": "diagnostics-header",
  "diagnostics-header__button": "diagnostics-header__button",
  "diagnostics-header__button--active": "diagnostics-header__button--active",
  "diagnostics-header__icon": "diagnostics-header__icon",
  "diagnostics-header__icon--ascending": "diagnostics-header__icon--ascending",
  "diagnostics-header__visually-hidden": "diagnostics-header__visually-hidden"
};
export {
  i as default
};
